import React from 'react'
import ButtonMailto from "./MailTo"
import { NavLink } from 'react-router-dom'
import "../css/footer.css"
import image from "../images"



function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <div>

            <div className="footer-div">
                <div className="row footer-row">
                    <div className="footer-column col-md-6 ">
                        <h3 className="navigate-heading">Navigate</h3>
                        <NavLink className="footer-option" to="/home">Homepage</NavLink>
                        <NavLink className="footer-option" to="/aboutus">About us</NavLink>
                        <NavLink className="footer-option" to="/contact">Contact</NavLink>
                        <a className="footer-option" href="https://www.amazon.in/hz/wishlist/ls/68D6XJ7HA7PJ?ref_=wl_share" aria-label="Amazon-pet-food" rel="noopener" target="_blank">Pet Food</a>
                        <a className="footer-option" href="https://www.amazon.in/hz/wishlist/ls/E90HH62SU2AU?ref_=wl_share" aria-label="Amazon-pet-accessories" rel="noopener" target="_blank">Pet Accessories</a>

                        {/* Donation Btn */}

                        <NavLink className="footer-donationBtn-link" to="/supportus" >
                            <button className="footer-donationBtn">SUPPORT US<img className="footer-donationImg" src={image.donationImg} alt="animals-profile" /></button>
                        </NavLink>

                    </div>


                    <div className="footer-column  col-md-6">
                        <h3 className="navigate-heading findUs">Find Us</h3>
                        <p className="footer-address">777 Hues Branch, Sector XX, Gurugram,  <br />Haryana 1220XX</p>
                        <p className="footer-mail">
                            Email: <ButtonMailto className="petMe-email" label="saifali.2021@gmail.com" mailto="mailTo:saifali.2021@gmail.com"></ButtonMailto>
                        </p>

                        <h3 className="navigate-heading footer-follow-Us">Follow Us!</h3>
                        <div className="row footer-media-row">
                            <div className="footer-handke-box ">
                                <i class="footer-handle-icon fa-brands fa-twitter"></i>
                            </div>
                            <div className="footer-handke-box ">
                                <i class="footer-handle-icon fa-brands fa-instagram"></i>
                            </div>
                            <div className="footer-handke-box">
                                <i class="footer-handle-icon fa-brands fa-facebook"></i>
                            </div>
                        </div>

                        {/* Donate Pet Btn */}

                        <NavLink className="footer-donatePet-link" to="/petData" >
                            <button className="footer-donatePet-Btn">DONATE PET<img className="footer-donatePetImg" src={image.dog_house} alt="dog-house" /></button>
                        </NavLink>

                    </div>
                </div>

                <p className="copyright">Copyright©{currentYear} PetMe All Rights Reserved</p>
            </div>

        </div>
    )
}

export default Footer